export default "__VITE_ASSET__B963lGAG__"